import React, {Component} from 'react';
import {Calendar} from 'primereact/calendar';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask'


export class ComponentsPeriodoDateInput extends Component {

    static defaultProps = {        
        onChange: null
    }

    static propTypes = {
        onChange: PropTypes.func
    }

    constructor(){
        super();

        this.state = {
            value : null
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({ value: props.value });
    }
 
    handleChange(event){
        this.setState({value: event.value}, this.callOnChange(event.value));  
        this.state.value = event.value;        
    }

    callOnChange(data){ 
        try
        {
            let event = {};
            event.ano = data.getFullYear();
            event.mes = data.getMonth() + 1;
            event.dia = data.getDate();
            this.props.onChange(event);
        }
        catch{}       
        /*/
        try
        {            
            if (this.props.onChange == null)
                return;

            if (this.state.value == null)
                return;

            let event = data;
            event.ano = this.state.value.getFullYear();
            event.mes = this.state.value.getMonth() + 1;
            event.dia = this.state.value.getDate();

            this.props.onChange(event);

            console.log(event);

        } 
        catch(error){

            console.log(error);            
        }                
        /*/
    }    

    
    

    render(){

        const locale = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
            dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
            dayNamesMin: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
            monthNames: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
            monthNamesShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dec"]
        };
        
        const dateFormat = 'dd/mm/yy';

        return (

            <Calendar 
                inputId={this.props.inputId}
                locale={locale}
                dateFormat={dateFormat}
                showOnFocus={false}
                showIcon={true}
                readOnlyInput={true}
                placeholder={this.props.placeholder}
                value={this.state.value} 
                onChange={this.handleChange}  
                readOnlyInput={false}          
                mask="99/99/9999"                   
            ></Calendar>
        );


    }
}